import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { RiscosService } from 'src/app/services/riscos.service';
import { RiscosChavesServices } from 'src/app/services/riscos-chaves.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { IRiscosModel } from 'src/app/models/riscos.model';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import { MatCheckboxChange } from "@angular/material/checkbox";
import { FiltroRisco } from 'src/app/models/filtro-risco.model';
import { IRiscosChavesModel, IRiscosChavesProcessoItemModel } from 'src/app/models/riscos-chaves.model';
import { ActivatedRoute, Router } from "@angular/router";
import { BaseFormComponent } from "../../../../shared/components/base-form/base-form.component";
import { ToastrService } from "ngx-toastr";
import { BsLocaleService } from "ngx-bootstrap/datepicker";

const sortingDataAccessor = (item, property) => {
  switch (property) {
    case 'versao': return item.versao.trim().toLowerCase();
    case 'data': return item.data.trim().toLowerCase();
    case 'situacao': return item.situacao.trim().toLowerCase();
    case 'ativo':
      return item.ativo;
    default:
      return item.versao;
  }
};

@Component({
  selector: 'app-modal-selecao-risco',
  templateUrl: './modal-selecao-risco.component.html',
  styleUrls: ['./modal-selecao-risco.component.scss']
})
export class ModalSelecaoRiscoComponent extends BaseFormComponent implements OnInit {

  public filtro =  {} as FiltroRisco;
  public semDados = true;
  public riscosChavesId: number;
  public totalItens: number;
  public selecionado: IRiscosModel;
  public displayedColumns: string[] = ['selecao', 'nome'];
  public dataSource = new MatTableDataSource<IRiscosModel>([]);
  public modelRiscosChaves: IRiscosChavesModel;
  public pageEvent: any;
  public searchAtivo = true;
  @ViewChild('TableOnePaginator', { static: true }) tableOnePaginator: MatPaginator;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @Output() idSelecionado = new EventEmitter<string>();

  constructor(private riscoService: RiscosService,
              private riscosChavesService: RiscosChavesServices,
              route: ActivatedRoute,
              router: Router,
              localeService: BsLocaleService,
              public toastr: ToastrService,
              public matDialog: MatDialog,
              private dialogRef: MatDialogRef<ModalSelecaoRiscoComponent>,
  ) {
    super(route, toastr, router, localeService, matDialog);
  }

  ngOnInit() {
    this.configurarFiltro();
    this.buscar();
  }

  private configurarFiltro() {
    this.filtro.pagina = this.tableOnePaginator.pageIndex + 1;
    this.filtro.itensPorPagina = this.tableOnePaginator.pageSize;
    this.filtro.colunaOrder = this.sort.active;
    this.filtro.ativo = this.searchAtivo;
    this.filtro.direcao = this.sort.direction;
  }

  public buscar() {
    console.log(this.filtro);
    this.riscoService.obterAtivos(this.filtro).then((res)=>{
    this.totalItens = res.dados.totalItens;
      // @ts-ignore
    this.dataSource = new MatTableDataSource<IRiscosModel>(res.dados.resultado);
    this.paginator = this.tableOnePaginator;
    this.dataSource.sort = this.sort;
    this.dataSource.sortingDataAccessor = sortingDataAccessor;
    this.dataSource._updateChangeSubscription();
    this.semDados = this.dataSource.filteredData.length === 0;

    }).catch((err)=> {
      this.exibirMensagemErro(err.mensagem);
    });
  }

  public async concluir() {

    this.dialogRef.close(this.selecionado);

  }
  public cancelar() {
    this.dialogRef.close(null);
  }

  public filtrar(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.semDados = this.dataSource.filteredData.length === 0;
  }

  onCheckboxChange(event: MatCheckboxChange, element: any){
    if (event.checked){
      this.selecionado = !this.selecionado || this.selecionado.id !== element.id ? element : null;
       this.idSelecionado = element.id;

    }
  }
  public async selecionar(item: IRiscosModel) {
    this.selecionado = !this.selecionado || this.selecionado.id !== item.id ? item : null;

  }

  pageChanged(e) {
    this.filtro.pagina = e.pageIndex + 1;
    e.pageIndex = this.filtro.pagina;
    this.filtro.itensPorPagina = e.pageSize;
    this.buscar();
  }
}
